module.exports = __webpack_public_path__ + "img/js_img.240537f6.png";